/**
 * External dependencies
 */
import { Component } from 'react'
import equal from 'fast-deep-equal/es6/react'
import PropTypes from 'prop-types'

import { DealProduct } from '~bookwormgb/components/placeholders'
import { ajaxUrl } from 'bookwormgb'

import $ from 'jquery'

/**
 * The All Products Block. @todo
 */
class Block extends Component {
	static propTypes = {

		/**
		 * The attributes for this block.
		 */
		attributes: PropTypes.object.isRequired,
	}

	constructor( props ) {
		super( props )
		this.state = { output: false }

		this.setOutput = this.setOutput.bind( this )
	}

	componentDidMount() {
		const { hasVisibilitySensor = false } = this.props

		if ( ! hasVisibilitySensor ) {
			this.setOutput()
		}
	}

	componentDidUpdate( prevProps ) {
		const { hasVisibilitySensor = false, isVisible = false } = this.props

		if( ! equal( this.props.attributes, prevProps.attributes ) ) {
			this.setOutput()
		} else if( hasVisibilitySensor && isVisible && ( ! this.state.output ) ) {
			this.setOutput()
		}
	}

	setOutput() {
		const { attributes } = this.props

		$.ajax( {
			type: 'POST',
			url: ajaxUrl,
			data: {
				action: 'bookwormgb_deal_product_block_output',
				attributes
			},
			dataType: 'json',
			success: function( response ) {
				if( response.success ) {
					this.setState( { output: response.output } )
				}
				$( this.el ).trigger( 'bookwormgb_deal_product_block_output_success', [ this.el, response, attributes ] )
			}.bind( this ),
			error: function(xhr, status, err) {
				this.setState( { output: err.toString() } )
			}.bind( this )
		} )
	}

	render() {
		const { attributes } = this.props

		if ( attributes.isPreview || ( ! this.state.output ) ) {
			return <DealProduct { ...attributes } />
		}

		/**
		 * Todo classes
		 *
		 * wp-block-{$this->block_name},
		 */
		return (
			<div ref={ el => this.el = el } dangerouslySetInnerHTML={ { __html: this.state.output } }></div>
		)
	}
}

export default Block